import { FC, useState } from 'react';

import { NamePath } from 'antd/es/form/interface';

import { InputFormItem } from '@/components/form';

import { CellData } from '../cell-data';

type TEditableInputFormItemProps = {
	name: NamePath;
	itemValue?: string | number;
};

export const EditableInputFormItem: FC<TEditableInputFormItemProps> = ({ name, itemValue }) => {
	const [editMode, setEditMode] = useState<boolean>(true);
	const [shouldAutofocus, setShouldAutofocus] = useState<boolean>(false);

	return editMode ? (
		<InputFormItem
			formItemProps={{
				name: name,
				rules: [{ required: false }],
				style: { marginBottom: 0 },
			}}
			inputProps={{
				autoComplete: 'given-name',
				maxLength: 255,
				autoFocus: shouldAutofocus,
				onBlur: (e) => {
					if (e.target.value === '') {
						e.preventDefault();
						e.stopPropagation();
						return;
					}

					setEditMode(false);
					setShouldAutofocus(true);
				},
			}}
		/>
	) : (
		<CellData
			style={{ width: '100%' }}
			onClick={() => {
				setEditMode(true);
			}}
		>
			{itemValue}
		</CellData>
	);
};
